import axios from "axios";

const model = "Containers";

export default {
  propertyInfoDocument(type) {
    return axios.get(`/${model}/propertyInfoDocument?type=${type}`, {
      responseType: "arraybuffer"
    });
  },

  uploadBlogFiles(formData) {
    return axios.post(`/${model}/gcp/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress: progressEvent => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        // You can emit progress here if needed
        console.log(`Upload Progress: ${percentCompleted}%`);
      }
    });
  }
};
